/**
 * `customFetch` (app/api/custom-fetch.ts) strips the platform's pure `{ data: T }`
 * envelope at runtime, but Orval's generated response types still describe the
 * un-stripped shape (one level too deep). Every workflow-service response is a
 * pure `{ data }` envelope, so the already-unwrapped payload lives directly on
 * `response.data`. This helper centralises that single reconciliation point.
 */
export const readEnvelope = <T>(response: { data: unknown }): T => response.data as T;
